/**
 * 検索条件設定に特集コードを取得するために使用するVO
 *
 */
export class FeatureCodeListModel {
    constructor(
        public featureCode: string,	// 特集コード
        public featureName: string,	// 特集名前
    ){}
}
  